import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaLicitacoesExpoAnt from '../../../components/licitacao/listar/expomacuco';


function ListaLicitacoesExpoAntScreen() {
    return (
        <Fragment>
            <Head titulo="Licitações realizadas para a Expo Macuco em anos anteriores a 2023" />
            <Header />
            <Container>
                <ListaLicitacoesExpoAnt />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaLicitacoesExpoAntScreen;